var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "c-bot-chat-list" } },
    [
      _c("a-table", {
        staticClass: "m-0 table-custom custom-table",
        attrs: {
          columns: _vm.columns,
          dataSource: _vm.getData(),
          locale: { emptyText: _vm.$t("message.noLiveSupportFound") },
          pagination: false,
          rowClassName: _vm.rowClassName,
          rowKey: "_id",
          size: "small",
        },
        on: { change: _vm.tableChange },
        scopedSlots: _vm._u([
          {
            key: "customDate",
            fn: function (data, item) {
              return _c(
                "div",
                {
                  key:
                    "customDate-(" + item._id + ")(" + _vm.$i18n.locale + ")",
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm._f("dateShorted")(item.createdDate)) +
                      "\n        "
                  ),
                ]
              )
            },
          },
          {
            key: "chatDurations",
            fn: function (data, item) {
              return _c(
                "div",
                {
                  key:
                    "chatDurations-(" +
                    item._id +
                    ")(" +
                    _vm.$i18n.locale +
                    ")",
                },
                [
                  item.status === "chatbot"
                    ? _c("PassedTimeCounter", {
                        attrs: { date: item.createdDate, suffix: " saniye" },
                      })
                    : _vm._e(),
                ],
                1
              )
            },
          },
          {
            key: "actions",
            fn: function (data, item) {
              return _c(
                "div",
                { key: "actions-(" + item._id + ")(" + _vm.$i18n.locale + ")" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex justify-content-end",
                      staticStyle: { "margin-right": "-10px !important" },
                    },
                    [
                      _c(
                        "a-popover",
                        {
                          attrs: {
                            placement: "bottom",
                            title: "",
                            trigger: "click",
                          },
                        },
                        [
                          _c("template", { slot: "content" }, [
                            _c("div", { staticClass: "content" }, [
                              (item.users || []).filter(function (w) {
                                return w === _vm.user._id
                              }).length === 0 &&
                              !_vm.observing.includes(item._id)
                                ? _c(
                                    "div",
                                    { staticClass: "d-flex flex-row" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "justify-content-start",
                                        },
                                        [_c("watch-icon")],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "justify-content-end pl-3 popoverFont cursorPointer",
                                          on: {
                                            click: function ($event) {
                                              return _vm.observe(item)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(_vm.$t("message.watch")) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "md-button",
                            {
                              staticClass: "custom-button",
                              attrs: { "data-v-step": "15" },
                            },
                            [_c("Actions")],
                            1
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "a-popover",
                        { attrs: { title: "", trigger: "click" } },
                        [
                          _c("template", { slot: "content" }, [
                            _c(
                              "div",
                              { staticClass: "px-2" },
                              [
                                _c(
                                  "b-row",
                                  { staticClass: "mb-3" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticStyle: {
                                          color: "#9ba2b6",
                                          "font-weight": "bold",
                                        },
                                        attrs: { md: "6" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("message.country")) +
                                            ":\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { md: "6" } }, [
                                      _vm._v(
                                        _vm._s(
                                          item.geoLocation
                                            ? item.geoLocation.country
                                            : "N/A"
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.$_.get(item, "geoLocation.city", false)
                                  ? _c(
                                      "b-row",
                                      { staticClass: "mb-3" },
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticStyle: {
                                              color: "#9ba2b6",
                                              "font-weight": "bold",
                                            },
                                            attrs: { md: "6" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("message.city")) +
                                                ":\n                                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("b-col", { attrs: { md: "6" } }, [
                                          _vm._v(_vm._s(item.geoLocation.city)),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "mb-3" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticStyle: {
                                          color: "#9ba2b6",
                                          "font-weight": "bold",
                                        },
                                        attrs: { md: "6" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("message.browser")) +
                                            ":\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { md: "6" } }, [
                                      _vm._v(
                                        _vm._s(
                                          item.visitor.browser
                                            ? item.visitor.browser
                                            : _vm.getUserAgentInfo(
                                                item.userAgent,
                                                "browser"
                                              )
                                        ) + "\n                                "
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "mb-3" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticStyle: {
                                          color: "#9ba2b6",
                                          "font-weight": "bold",
                                        },
                                        attrs: { md: "6" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("message.os")) +
                                            ":\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { md: "6" } }, [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            item.visitor.os
                                              ? item.visitor.os
                                              : _vm.getUserAgentInfo(
                                                  item.userAgent,
                                                  "os"
                                                )
                                          ) +
                                          "\n                                "
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "mb-3" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticStyle: {
                                          color: "#9ba2b6",
                                          "font-weight": "bold",
                                        },
                                        attrs: { md: "6" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("message.visitStart")) +
                                            ":\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { md: "6" } }, [
                                      _vm._v(
                                        _vm._s(_vm._f("date")(item.createdDate))
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "md-button",
                            {
                              staticClass: "custom-button",
                              attrs: { "data-v-step": "14" },
                            },
                            [_c("Information")],
                            1
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      (item.users || []).filter(function (w) {
                        return w === _vm.user._id
                      }).length === 0 && !_vm.observing.includes(item._id)
                        ? _c(
                            "md-button",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "bottom-end",
                                    theme: _vm.isDarkMode
                                      ? "light-border"
                                      : "google",
                                  },
                                  expression:
                                    "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                        theme: isDarkMode ? 'light-border' : 'google',\n                    }",
                                },
                              ],
                              staticClass: "custom-button",
                              attrs: {
                                content: _vm.$t("message.watch"),
                                "data-v-step": "13",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.observe(item)
                                },
                              },
                            },
                            [
                              _c("a-icon", {
                                staticStyle: {
                                  "font-size": "14px",
                                  color: "#49c550",
                                },
                                attrs: { theme: "filled", type: "eye" },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-end mt-3",
          staticStyle: { "margin-bottom": "100px" },
        },
        [
          _c("Pagination", {
            attrs: {
              "page-change": _vm.pageChange,
              "page-sizes": _vm.pageSizes,
              total: _vm.totalChatCount,
              "data-v-step": "17",
              pageSizeLocalStorageKey: "chatbot-chatlist-page-size",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }